module.exports = __webpack_public_path__ + "static/media/5.Crumble me (ft. Josh Biltekoff).7aa50251.mp3";